import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import intro from 'intro.js' // introjs库
import 'intro.js/introjs.css' // introjs默认css样式
// introjs还提供了多种主题，可以通过以下方式引入
import 'intro.js/themes/introjs-modern.css'
import dataV from '@jiaminghi/data-view'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import dycrouter from './router/dycrouter.js'
import * as echarts from 'echarts'
import store from './store'
import './assets/css/iconfont.css'
import './style/index.css'
import './style/darkindex.scss'
import './style/element/index.scss'
import http from '@/api/config'
import Global from './unit/global'
import API from './unit/api'
import filter from './unit/filter'
import uuid from './unit/unit'
import img from './unit/Upload'
import attribute from './unit/attribute'
import vue3TreeOrg from 'vue3-tree-org'
import VueMarkdownEditor from '@kangc/v-md-editor';
import '@kangc/v-md-editor/lib/style/base-editor.css';
import vuepressTheme from '@kangc/v-md-editor/lib/theme/vuepress.js';
import '@kangc/v-md-editor/lib/theme/style/vuepress.css';
import Prism from 'prismjs';

import VMdPreview from '@kangc/v-md-editor/lib/preview'
import VMdEditor from '@kangc/v-md-editor'
import '@kangc/v-md-editor/lib/style/preview.css'
import '@kangc/v-md-editor/lib/style/base-editor.css'
import githubTheme from '@kangc/v-md-editor/lib/theme/github.js'
import '@kangc/v-md-editor/lib/theme/style/github.css'
// highlightjs
import hljs from 'highlight.js'
VMdPreview.use(githubTheme, {
  Hljs: hljs
})

VMdEditor.use(githubTheme, {
  Hljs: hljs
})


VueMarkdownEditor.use(vuepressTheme, {
  Prism,
});

//import './style/free.css'
// main.js

// import "vue3-tree-org/lib/vue3-tree-org.css";
//createApp.prototype.$http = http
router.beforeEach((to, from, next) => {
  //Global.msgload();
  store.commit('getloaddate')
  store.commit('changepath',to.path)
  // 防止刷新后vuex里丢失token
  //store.commit("getToken");
  // 防止刷新后vuex里丢失标签列表tagList
  const role = localStorage.getItem('ms_username')
  const token = localStorage.getItem('accessToken')
  const round = store.state.user.round
  if (to.matched.length === 0) {
    //未匹配到的时候跳转到404页面
    next({ name: '404' })
  }
  //   console.log(token)
  // 过滤登录页，防止死循环
  // 筹建阶段过则不能进入主界面
  //1.判断是否登录
  if (role == null && to.path !== '/') {
    next('/')
  }
  //2已登录, 需要过滤没有选择实验的
  else if (
    to.path !== '/guide' &&
    !token &&
    to.path !== '/selectiveexperiment' &&
    to.path !== '/'&&
    to.path !== '/History' &&
    to.path !== '/Previewtopic' &&
    to.path !== '/ScoringRules' 
  ) {
    next('/')
  } else if (
    to.path !== '/selectiveexperiment' &&
    to.path !== '/' &&
    parseInt(round) < 1 && 
    to.path !== '/History' &&
    to.path !== '/Previewtopic' &&
    to.path !== '/ScoringRules' 
  ) {
    next('/')
  } else {
    next()
  }
})
const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
// app.directive('el-select-loadmore',{
//   bind(el,binding){
//       const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
//       SELECTWRAP_DOM.addEventListener('scroll', function (){
//           const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
//           if (condition) {
//               binding.value();
//           }
//       })
//   }
// })
app.config.globalProperties.$dycrouter = dycrouter
app
  .use(store)
  .use(router)
  .use(ElementPlus)
  .use(vue3TreeOrg)
  .use(dataV)
  .use(intro)
  .use(VueMarkdownEditor)
  .use(VMdPreview)
  .use(VMdEditor)
  .mount('#app')
app.config.globalProperties.$http = http
app.config.globalProperties.$router = router
app.config.globalProperties.Global = Global
app.config.globalProperties.filter = filter
app.config.globalProperties.uuid = uuid
app.config.globalProperties.img = img
app.config.globalProperties.echarts = echarts
app.config.globalProperties.attribute = attribute
app.config.globalProperties.API = API
app.config.globalProperties.intro = intro
